// import GraniteError from 'granite-admin/utils/granite-error'
// FIXME: icons should be sent by backend
// function insertIcon(label) {
//   switch (label) {
//     case 'Dashboard':
//       return <Dashboard size="16px" color="brand" />
//     case 'Employees':
//       return <Group size="16px" color="brand" />
//     case 'Tracking':
//       return <Location size="16px" color="brand" />
//     case 'Timecards':
//       return <Clock size="16px" color="brand" />
//     case 'Job Center':
//       return <ScheduleNew size="16px" color="brand" />
//     case 'Reports':
//       return <LineChart size="16px" color="brand" />
//     default:
//       break
//   }
// }

function Sidemenu(data) {
  this.name = data.name;
  this.sequence = data.sequence;
  this.parentId = data.parent_id;
  this.path = data.name.replace(/\./g, '/');
  this.label = data.label;
  this.icon = data.icon;
  this.permissions = data.permissions;
  this.pk = data.pk;
  this.group = data.group.toUpperCase();
  this.isActive = data.is_active;
  this.url = data.url;
  this.extra_data = data.extra_data;
  this.getlabel = function () {
    return this.label;
  };
  this.geticon = function () {
    return this.icon;
  };
  this.getpath = function () {
    return this.path;
  };
  this.getsequence = function () {
    return this.sequence;
  };
  this.toString = function () {
    return 'sideMenu';
  };
  this.toJSON = function () {
    const data = {
      sequence: this.sequence,
      path: this.path,
      label: this.label,
      parentId: this.parentId,
      icon: this.icon,
      pk: this.pk
    };
    return data;
  };
  this.copy = function (obj, properties = {}) {
    const existingProps = obj.toJSON();
    const updatedProps = Object.assign(existingProps, properties);
    const {
      username,
      ...rest
    } = updatedProps;
    return new Sidemenu(username, rest);
  };
}
export default Sidemenu;